import React, { useState, useEffect, useRef } from 'react';

import EditModalShell from '../forms/EditModalShell/EditModalShell';
import LoadingModal from '../LoadingModal/LoadingModal';
import AdminProgressBar from '../../AdminProgressBar/AdminProgressBar';
import FormField from '../forms/FormField/FormField';

import './BlogPostCommentModal.css';

const BlogPostCommentModal = ({
  onClose,
  onSubmit,
  comment,
  mode,
  errorMsg,
}) => {
  const initialFormState = {
    name: '',
    email: '',
    website: '',
    content: '',
  };

  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const { name, email, website, content } = formData;

  const firstInputRef = useRef();

  /* ---------- Init ---------- */

  useEffect(() => {
    setFormData({
      name: comment?.name || '',
      email: comment?.email || '',
      website: comment?.website || '',
      content: comment?.content || '',
    });

    firstInputRef.current?.focus();
  }, [mode, comment]);

  /* ---------- Handlers ---------- */

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  /* ---------- Submit ---------- */

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setProgress(0);

    try {
      const finalData = { ...formData };

      setProgress(100);

      await onSubmit(finalData);
    } catch (err) {
      console.error(err);
      alert('Upload failed.');
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  /* ---------- Render ---------- */

  return (
    <EditModalShell
      formId='comment-modal-form'
      onClose={onClose}
      onSubmit={handleSubmit}
      mode={mode}
      isLoading={loading}
      itemLabel='Comment'
    >
      {loading && (
        <LoadingModal>
          <AdminProgressBar progress={progress} message='Saving' />
        </LoadingModal>
      )}

      <div className='comment-modal-content-container'>
        <div className='comment-modal-pages-container'>
          <div className='comment-modal-blog-page-container'>
            {/* Error */}
            <div className='comment-modal-error-container'>
              {errorMsg && <span>{errorMsg}</span>}
            </div>

            <FormField
              type='text'
              name='name'
              label='Name'
              value={name}
              onChange={handleInputChange}
              ref={firstInputRef}
              required
            />

            <FormField
              type='email'
              name='email'
              label='Email'
              value={email}
              onChange={handleInputChange}
              autoComplete='on'
              required
            />

            <FormField
              type='url'
              name='website'
              label='Website'
              value={website}
              onChange={handleInputChange}
              autoComplete='on'
            />

            <FormField
              type='textarea'
              name='content'
              label='Comment'
              value={content}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
      </div>
    </EditModalShell>
  );
};

export default BlogPostCommentModal;
